'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdVoicemail = function MdVoicemail(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.9 25c3.2 0 5.7-2.7 5.7-5.9s-2.5-5.7-5.7-5.7-5.9 2.5-5.9 5.7 2.7 5.9 5.9 5.9z m-21.8 0c3.2 0 5.9-2.7 5.9-5.9s-2.7-5.7-5.9-5.7-5.7 2.5-5.7 5.7 2.5 5.9 5.7 5.9z m21.8-15c5 0 9.1 4.1 9.1 9.1s-4.1 9.3-9.1 9.3h-21.8c-5 0-9.1-4.2-9.1-9.3s4.1-9.1 9.1-9.1 9.3 4.1 9.3 9.1c0 2.2-0.8 4.3-2.1 5.9h7.5c-1.4-1.6-2.2-3.7-2.2-5.9 0-5 4.2-9.1 9.3-9.1z' })
        )
    );
};

exports.default = MdVoicemail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/voicemail.js
// module id = 1337
// module chunks = 0